import { useCallback, useContext } from 'react';
import { useDispatch } from 'react-redux';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { CommentableTypes } from '../../../Comment/redux/types';
import { getCommentBoxId } from '../../../CommentThread/helpers';
import { focusEditor as focusEditorNew } from '../../../CommentEditor/redux/actionCreators';
import { scrollIntoViewWithHeader } from '../../../utils/scrollIntoViewWithHeader';

/** Returns a dispatched action that will focus on the comment box with the given ids */
export default function useFocusOnCommentBox(
  commentableTypeId: CommentableTypes,
  commentableItemId: number,
  position: string,
  scrollIntoView: boolean = true,
  extraHeaderHeight: number = 0
) {
  const dispatch = useDispatch();
  const commentBoxId = getCommentBoxId(
    commentableTypeId,
    commentableItemId,
    position
  );

  const isMobile = useContext(MobileContext);
  return useCallback(() => {
    dispatch(focusEditorNew(commentBoxId));
    if (scrollIntoView && typeof document !== 'undefined') {
      const boxElement = document.getElementById(commentBoxId);
      boxElement &&
        scrollIntoViewWithHeader(
          boxElement,
          isMobile,
          extraHeaderHeight,
          undefined,
          true,
          true
        );
    }
  }, [dispatch, commentBoxId, scrollIntoView, isMobile, extraHeaderHeight]);
}
